import {
  FEAASCDNStylesheetProps,
  fetchAndRevalidateStylesheet,
  getStylesheetURL,
  ValidatableStylesheetCallback
} from '../cdn.js'

export function renderStylesheet(props: FEAASCDNStylesheetProps, style?: HTMLStyleElement) {
  renderStylesheetPromise(props, (style ||= document.createElement('style')))
  return style
}

export function renderStylesheetPromise(props: FEAASCDNStylesheetProps, stylesheet?: HTMLStyleElement) {
  stylesheet ||= document.createElement('style')
  return fetchAndRevalidateStylesheet(props, (cssText, phase) => {
    stylesheet.textContent = cssText
  }).then(() => stylesheet)
}

export function loadStylesheet(props: FEAASCDNStylesheetProps, callback?: ValidatableStylesheetCallback) {
  var foundStylesheet = findStylesheet(props) as HTMLStyleElement
  if (!foundStylesheet) {
    var createdStylesheet = createStylesheet(props)
  }
  return fetchAndRevalidateStylesheet(props, (cssText, phase) => {
    if (createdStylesheet) {
      createdStylesheet.textContent = cssText
    }
    callback?.(cssText, phase)
  }).then(() => foundStylesheet || createdStylesheet)
}

export function loadStylesheetAllowStale(props: FEAASCDNStylesheetProps) {
  return new Promise((resolve, reject) => {
    loadStylesheet(props, resolve).catch(reject)
  })
}

export function findStylesheet(props: FEAASCDNStylesheetProps) {
  return document.head.querySelector(`style[data-href="${getStylesheetURL(props)}"]`)
}

export function createStylesheet(props: FEAASCDNStylesheetProps) {
  const url = getStylesheetURL(props)
  const stylesheet = document.createElement('style')
  stylesheet.setAttribute('data-href', url)
  document.head.appendChild(stylesheet)
  return stylesheet
}
